'use client';

import { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Main from '@/components/main';

const PATREON_URL = 'https://www.patreon.com/bePatron?u=28468188';
const PAYPAL_URL = 'https://www.paypal.com/donate/?hosted_button_id=MCW62PKB3CL9E';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export default function SupportPageClient() {
  const trackOutboundClick = useCallback((platform: string) => {
    const ref = new URLSearchParams(window.location.search).get('ref');
    window.gtag?.('event', 'support_outbound_click', {
      event_category: 'support',
      event_label: platform,
      support_ref: ref || 'direct',
    });
  }, []);

  return (
    <Main compact>
      <Typography variant="h1">Support Everyday Rides</Typography>

      <p>
        Everyday Rides is a free community calendar built and run by one person. It costs
        about $120 a month to keep online. If the calendar is useful to you, please consider
        supporting the site.
      </p>

      <Typography variant="h2">How to Donate</Typography>

      <p>
        Monthly donations through Patreon make the site&apos;s costs predictable, and
        one-time donations through PayPal are always appreciated.
      </p>

      <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'wrap', my: 2 }}>
        <Button
          component="a"
          href={PATREON_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackOutboundClick('patreon')}
          variant="outlined"
          sx={{
            borderColor: '#ff424d',
            color: '#ff424d',
            '&:hover': { borderColor: '#e03a44', bgcolor: 'rgba(255,66,77,0.04)' },
          }}
        >
          Monthly on Patreon
        </Button>
        <Button
          component="a"
          href={PAYPAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackOutboundClick('paypal')}
          variant="outlined"
          sx={{
            borderColor: '#0070ba',
            color: '#0070ba',
            '&:hover': { borderColor: '#005ea6', bgcolor: 'rgba(0,112,186,0.04)' },
          }}
        >
          One-time with PayPal
        </Button>
      </Stack>

      <Typography variant="h2">What Donations Cover</Typography>

      <p>
        Donations go toward the monthly costs of running the site: servers, the database, and
        email delivery. Anything beyond those costs goes toward building new features for the
        community.
      </p>

      <Typography variant="h2">What Stays Free</Typography>

      <p>
        The calendar is free for everyone. Finding rides, posting events, joining groups,
        and RSVPing will stay that way. Donations keep the site running; they never unlock
        features.
      </p>
    </Main>
  );
}
